<template>
  <modal
    content-class="domain-authenticate-modal"
    :title="$t('message.email.message.authenticateDomain')"
    :max-width="maxWidth"
    :value="showing"
    @input="emitShowing"
  >
    <domain-authenticate-form
      v-if="showing"
      @step="setModalMaxWidth"
      @validated="onValidated"
    />
  </modal>
</template>

<script>
import DomainAuthenticateForm from "@components/modules/domain/authenticate/form/DomainAuthenticateForm";
import Modal from "@components/generic/Modal.vue";

export default {
  components: {
    Modal,
    DomainAuthenticateForm,
  },
  data() {
    return {
      total: 0,
      loading: false,
      maxWidth: 800,
    };
  },
  props: {
    showing: {
      type: Boolean,
      default: false,
    },
  },

  created() {},

  computed: {},

  watch: {},

  methods: {
    hide() {
      this.emitShowing(false);
    },
    setModalMaxWidth(step) {
      if (step === 1) {
        this.maxWidth = 800;
      } else {
        this.maxWidth = `80%`;
      }
    },
    emitShowing(val) {
      this.$emit("update:showing", val);

      if (!val) {
        this.$emit("closed");
      }
    },
    onValidated(isValid) {
      if (isValid) {
        this.hide();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.domain-modal {
  .domain-modal-action {
    margin: 0 auto;
    display: block;
    border-radius: 20px !important;
  }
}
</style>
